// extracted by mini-css-extract-plugin
export default {"checkbox":"EditPackNameModal_checkbox__PdnT-","button":"EditPackNameModal_button__DF+1o"};